export { Popup as DeleteStorePopup } from './popup'
